import { useState } from 'react';
import { useDevedor } from '../../../context/ConsultContext';
import { useInvoicesTable } from '../../../context/TableContext';
import { useLoading } from '../../../hooks/useLoading';
import { api } from '../../../services/api';
import { InputDateMask } from '../../Inputs/InputDateMask/InputDateMask';
import { Loader } from '../../Loader/Loader';
import {
  ContainerBackground,
  Container,
  ModalContainer,
  ModalBody,
  InputBlock,
  Button,
} from '../styles';

export const EditModal = () => {
  const {
    openEditModal,
    idParcela,
    faturaParcela,
    page,
    listarFaturas,
    setTableSelected,
    setMudarFaturaParcela,
  } = useInvoicesTable();

  const { cpf } = useDevedor();

  const { hideLoader, showLoader, loader } = useLoading();

  const [valor, setValor] = useState('');
  const [vencimento, setVencimento] = useState('');

  const parcela = faturaParcela.parcelas.find(
    (parcela) => parcela.nroparc === idParcela.nroparc,
  );

  async function handleSubmit(
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) {
    e.preventDefault();

    if (valor === '' && vencimento === '') {
      openEditModal();
      return;
    }

    if (page === 'register') {
      const index = faturaParcela.parcelas.findIndex(
        (parcela) =>
          parcela.nroparc === idParcela.nroparc &&
          parcela.documento === idParcela.documento,
      );

      const venc = vencimento
        ? vencimento.split('/').reverse().join('-')
        : faturaParcela.parcelas[index].vencimento;

      const valorParc = valor.replace(',', '.');

      faturaParcela.parcelas[index].valorparc = valor
        ? Number(valorParc)
        : faturaParcela.parcelas[index].valorparc;
      faturaParcela.parcelas[index].vencimento = venc;

      setMudarFaturaParcela(faturaParcela);
    } else {
      const parcela = faturaParcela.parcelas.find(
        (parcela) => parcela.nroparc === idParcela.nroparc,
      );

      showLoader();
      const response = await api.put(`/parcela/update/vencimento`, {
        documento: idParcela.documento,
        nroparc: idParcela.nroparc,
        cpf,
        valor: valor ? Number(valor) : parcela?.valorparc,
        vencimento: vencimento
          ? vencimento.split('/').reverse().join('-')
          : parcela?.vencimento,
        valorFatura: faturaParcela.fatura.valorfatura,
        valorAnterior: parcela?.valorparc,
      });

      listarFaturas(response.data.faturas_parc);
      setTableSelected(response.data.documento);
    }

    openEditModal();
    hideLoader();
  }

  return (
    <ContainerBackground>
      <Container>
        <ModalContainer>
          <ModalBody>
            <form>
              <InputBlock>
                <label>Valor da parcela</label>
                <input
                  type="text"
                  placeholder={`${parcela?.valorparc}`}
                  onChange={(e) => setValor(e.target.value)}
                />
              </InputBlock>

              <InputBlock>
                <label>Vencimento</label>
                <InputDateMask
                  type="text"
                  name="vencimento"
                  placeholder={parcela?.vencimento
                    .split('-')
                    .reverse()
                    .join('/')}
                  onChange={(e) => setVencimento(e.target.value)}
                />
              </InputBlock>

              <Button type="button" onClick={(e) => handleSubmit(e)}>
                Confirmar
              </Button>
            </form>
          </ModalBody>
        </ModalContainer>
      </Container>
      {loader && <Loader />}
    </ContainerBackground>
  );
};
